import filter from 'lodash/filter'
import includes from 'lodash/includes'
import map from 'lodash/map'
import React, { FC, useContext, useMemo } from 'react'

import { Bar } from '@Components/Bar'
import { RTEContent } from '@Components/RTEContent'
import { getRTEFieldText } from '@Globals/CMS/FieldHelpers'
import { MetadataContext } from '@Globals/Metadata'

interface Props {
  placement: string
}

export const CMSBar: FC<Props> = ({ placement }) => {
  const { bars } = useContext(MetadataContext)
  const filteredBars = useMemo(() => filter(bars, bar => includes(bar.placement, placement)), [bars, placement])

  return (
    <>
      {map(filteredBars, (bar) => {
        const content = getRTEFieldText(bar.fields || [], 'text')
        return (
          <Bar
            key={bar.id}
            background={bar.backgroundColor}
            color={bar.textColor}
            id={`bar-${placement}-${bar.id}`}
            variant={placement === 'top' ? 'default' : 'contained'}
          >
            <RTEContent html={content} />
          </Bar>
        )
      })}
    </>
  )
}
